import { array, boolean, nullable, number, object, string } from "superstruct";

import { ProductImageSchema } from "./ProductImageSchema";
import { ProductOptionsSchema } from "./ProductOptionsSchema";
import { ProductVariantSchema } from "./ProductVariantsSchema";

export const ProductSchema = object({
    id: number(),
    title: string(),
    description: string(),
    handle: string(),
    featuredImage: nullable(ProductImageSchema),
    images: array(ProductImageSchema),
    variants: array(ProductVariantSchema),
    options: array(ProductOptionsSchema),
    product_wish_button: nullable(boolean()),
    tags: array(string()),
});
